import { gql } from 'apollo-boost';

const academicYearReportsQuery = `
id
activeAccounts
purchasedAccounts
activeParents
academicYear
groupBooksCompleted
homeBooksCompleted
libraryBooksCompleted
schoolBooksCompleted
totalBooksCompleted
parentLogs
studentLogs
teacherLogs
totalLogs
topBooksCompleted {
    id
    title
    author
}
`;

export const SCHOOL_USAGE_SCORE = gql`
query schoolUsageScore($support: String, $orderBy: String) {
    schoolUsageScore(support: $support, orderBy: $orderBy) {
        id
        school {
            id
            name
            schoolCode
            admins {
                id
                email
            }
        }
        schoolScore
        teachersEngagementPercentage
        studentLogs
        teacherLogs
        parentLogs
    }
}
`;

export const HIGH_USAGE_SCHOOLS = gql`
query highUsageSchools($orderBy: String!) {
    highUsageSchools(orderBy: $orderBy) {
        id
        school {
            id
            name
            schoolCode
        }
        studentAverageMonthlyLogs
        teacherAverageMonthlyLogs
        parentAverageMonthlyLogs
    }
}
`;

export const SCHOOL_MONTHLY_REPORT_DATA = gql`
query schoolByCode($schoolCode: ID!, $academicYear: Int!) {
    schoolByCode(schoolCode: $schoolCode) {
        id
        monthlyReportData(academicYear: $academicYear) {
            id
            activeAccounts
            purchasedAccounts
            activeParents
            academicYear
            groupBooksCompleted
            homeBooksCompleted
            libraryBooksCompleted
            schoolBooksCompleted
            totalBooksCompleted
            parentLogs
            studentLogs
            teacherLogs
            totalLogs
            topBooksCompleted {
                id
                title
                author
            }
            month
        }
    }
}
`;


export const GET_SCHOOL_BY_ID = gql`
query school($schoolId: ID!) {
    school(schoolId: $schoolId) {
        id
        schoolCode
        name
        avatarUrl
        admins {
            id
            displayName
            email
        }
        students {
            id
        }
        schoolPhoneNumber
        city
        zip
    }
}
`;

export const ADMIN_STATS = gql`
query adminStats($academicYear: Int) {
    adminStats(academicYear: $academicYear) {
        id
        key
        value
        appStats {
            activeParentsCount
            activeSchoolsCount
            activeStudentsCount
            activeTeachersCount
            cancelledSchoolsCount
            nonWondeSchoolCount
            wondeSchoolsCount
            lowUsageSchools
            highUsageSchools
            lowTakeupSchools
        }
    }
}
`;

export const ACADEMIC_MONTHLY_REPORTS = gql`
query academicMonthlyReports($academicYear: Int, $calendarYear: Int) {
    academicMonthlyReports(academicYear: $academicYear, calendarYear: $calendarYear) {
        id
        academicYear
        avgGroupBooks
        avgHomeBooks
        avgLibraryBooks
        avgParentLogs
        avgSchoolBooks
        avgStudentLogs
        avgTeacherLogs
        month
        studentsCount
        totalBooks
        totalGroupBooks
        totalHomeBooks
        totalLibraryBooks
        totalLogs
        totalParentLogs
        totalSchoolBooks
        totalStudentLogs
        totalTeacherLogs
        year
    }
}
`;